import { routesPath } from "conts/routes";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { Container } from "ui/base/Container";
import { SocFacebookIcon, SocInstIcon, SocTwitterIcon } from "ui/icons";
import { defaultThemeColors, fonts, mediaSizes, pageContainerStyles } from "ui/theme";

import { useAuth } from "context/AuthContext";
import { userRoute } from "pages/user/user.routes";
import { pixelTrackEvent } from "utils/facebookPixel";

export const FooterVariant = () => {
  const { token } = useAuth();
  const { pathname } = useLocation();

  return (
    <FooterWrapper id="app-footer">
      <Container wide>
        <Row>
          <Social>
            <SocialItem
              target="_blank"
              href="https://www.instagram.com/teache.app/"
            >
              <SocInstIcon />
            </SocialItem>
            <SocialItem
              target="_blank"
              href="https://www.facebook.com/Teacheapp/"
            >
              <SocFacebookIcon />
            </SocialItem>
            <SocialItem target="_blank" href="https://twitter.com/teache_app">
              <SocTwitterIcon />
            </SocialItem>
          </Social>
          <Links>
            {token ? (
              <Link
                to={userRoute.myClasses}
                onClick={() =>
                  pathname === routesPath.main
                    ? pixelTrackEvent("Footer: Clicked on My Classes")
                    : null
                }
              >
                My Classes
              </Link>
            ) : (
              <Link
                to={routesPath.about}
                onClick={() =>
                  pathname === routesPath.main
                    ? pixelTrackEvent("Footer: Clicked on About Us")
                    : null
                }
              >
                About Us
              </Link>
            )}
            {!token && (
              <Link
                to={routesPath.faq}
                onClick={() =>
                  pathname === routesPath.main
                    ? pixelTrackEvent("Footer: Clicked on  faq")
                    : null
                }
              >
                FAQs
              </Link>
            )}
            {/* TODO: need to add correct url for privacy, couldn't find similar matchs */}
            {!token && (
              <Link
                to={routesPath.faq}
                onClick={() =>
                  pathname === routesPath.main
                    ? pixelTrackEvent("Footer: Clicked on  faq")
                    : null
                }
              >
                Privacy
              </Link>
            )}
            <Link
              to={routesPath.terms}
              onClick={() =>
                pathname === routesPath.main
                  ? pixelTrackEvent("Footer: Clicked on Terms")
                  : null
              }
            >
              Terms
            </Link>
          </Links>
          <ColText>
            <CopyRightText>
              Copyright © {new Date().getFullYear()} Teache. All rights reserved
            </CopyRightText>
          </ColText>
        </Row>
      </Container>
    </FooterWrapper>
  );
};

const FooterWrapper = styled.div`
  background-color: ${defaultThemeColors.secondary};
  color: ${defaultThemeColors.txt};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  ${pageContainerStyles}
  padding: 0.8rem 0;
  gap: 1rem;
  flex-wrap: wrap;
  @media (width >= ${mediaSizes.sm}) {
    padding-inline: 0; 
  }
  @media (width >= ${mediaSizes.xl}) {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 3rem;
    
  }

`;

const ColText = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const Text = styled.div`
  text-align: left;
  font-family: var(--font-primary);
  font-weight: 400;
  line-height: 21px;

  @media (width >= ${mediaSizes.md}) {
    font-size: ${fonts.sizes.small};
  }
`;

const Social = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
`;

const SocialItem = styled.a`
  cursor: pointer;
  width: 25px;
  height: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  & svg {
    fill: ${defaultThemeColors.txt};
    transition: all 0.2s;
  }

  &:hover {
    svg {
      opacity: 0.7;
    }
  }
`;

const Links = styled.div`
  display: flex;
  align-items: center;
  font-family: var(--font-primary);
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  @media (width >= ${mediaSizes.xl}) {
    gap: 1rem 3rem;
  }
  & a {
    font-size: ${fonts.sizes.small};
    text-align: left;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const CopyRightText = styled.p`
  font-family: var(--font-primary);
  font-size: ${fonts.sizes.small};
`;
